<template>
    <div>
        <a-button class="top_btn" type="primary"  @click="()=>{visibleForm = true; titleForm='添加菜单',this.ids='';this.editId=''; }"  v-has="'btn_add'"> 添加
        </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()" v-has="'btn_listorder'"> 排序</a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
      <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
      </span>
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete','btn_add'])" style="color:#838383">暂无操作权限</i>
                <a @click="(record) => { visibleForm = true; titleForm='添加子菜单';ids=text.id ; editId=''; }" v-has="'btn_add'">添加子菜单 <a-divider type="vertical"/></a>
                <a @click="(record)=>{visibleForm = true; titleForm='修改菜单',editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider  type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>

        <CreateForm
                :visible="visibleForm"
                :formEdit="formVal"
                :ids="ids"
                :editId="editId"
                :title="titleForm"

                @changVisible=" () => { this.visibleForm = false; this.ids='';this.editId='';this.getList()}  "></CreateForm>
    </div>
</template>

<script>
    import API from "./api";
    import CreateForm from "./components/createForm";

    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            key: "list_order",
            width: "18%",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "ID",
            dataIndex: "id",
            width: "10%",
            key: "id"
        },
        {
            title: "菜单名称",
            dataIndex: "title",
            width: "15%",
            ellipsis: true,
            key: "title"
        },
        {
            title: "路径",
            dataIndex: "path",
            ellipsis: true,
            key: "path"
        },
        {
            title: "状态",
            key: "status",
            width: "10%",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];


    export default {
        name: "MenuList",
        data() {
            return {
                spinnings:true,
                loading: true,
                visibleForm: false,
                formVal: {},
                titleForm: "",
                ids: "",
                editId: "",
                data: [],
                sortLists: [],
                columns,

            };
        },
        components: {CreateForm},
        created () {
            this.$store.state.adminleftnavnum="/Menu/MenuLists"; //设置左侧导航2-2 active
        },
        methods: {
            getchangId(data) {

                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < data.length; i++) {
                    sortListOrder.id = data[i].id
                    sortListOrder.list_order = data[i].list_order
                    this.sortLists.push(sortListOrder)
                    sortListOrder = {}
                    if (data[i].children && data[i].children.length > 0) {
                        this.getchangId(data[i].children)
                    }
                }
            },

            listOrder() {
                this.sortLists=[]
                this.getchangId(this.data)
                let changKey = 'updatable';
                let hide = this.$message.loading({content:'正在修改',key:changKey} )
                API.menu.LIST_ORDER(this.sortLists).then(res => {
                    if (res.data.code === 200) {
                        hide();
                        this.$message.success({ content:"修改成功", key:changKey, duration: 2 })
                        this.getList()
                    }
                })
                // API.menu.LIST_ORDER(this.sortLists).then(res => {
                //     this.getList()
                // })
            },
            confirm(row) {
                API.menu.DELE([row.id]).then(res => {
                    this.getList()
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                API.menu.CHANG_STATUS([Json]).then(res => {
                    this.getList()
                })
            },
            getList() {
                API.menu.GET_MENULIST().then(res => {
                    res.data.data.map((item, index) => {
                        item.key = item.id
                        if (item.children && item.children.length > 0) {
                            item.children.map((items, indexs) => {
                                items.key = items.id
                            })
                        }
                    })
                    this.data = res.data.data
                    this.loading = false
                    this.sortLists=[]
                })
            }
        },

        mounted() {
            this.getList()
        },

    };
</script>

<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
